export const uiTranslations = {
  // Promo/Banners
  'promo.title': {
    ru: 'Наши преимущества',
    kz: 'Біздің артықшылықтарымыз',
    en: 'Our Advantages'
  },
  'promo.modern': {
    ru: 'Современное оборудование',
    kz: 'Заманауи жабдықтар',
    en: 'Modern Equipment'
  },
  'promo.professional': {
    ru: 'Профессиональные врачи',
    kz: 'Кәсіби дәрігерлер',
    en: 'Professional Doctors'
  },
  'promo.individual': {
    ru: 'Индивидуальный подход',
    kz: 'Жеке тәсіл',
    en: 'Individual Approach'
  },
  'promo.complex': {
    ru: 'Комплексная диагностика',
    kz: 'Кешенді диагностика',
    en: 'Comprehensive Diagnostics'
  },

  // Contact Section
  'contact.title': {
    ru: 'Вопросы и отзывы',
    kz: 'Сұрақтар мен пікірлер',
    en: 'Questions and Reviews'
  },
  'contact.information': {
    ru: 'Контактная информация',
    kz: 'Байланыс ақпараты',
    en: 'Contact Information'
  },
  'contact.form': {
    ru: 'Форма обратной связи',
    kz: 'Кері байланыс формасы',
    en: 'Feedback Form'
  },
  'contact.address': {
    ru: 'Адрес',
    kz: 'Мекенжай',
    en: 'Address'
  },
  'contact.address.value': {
    ru: 'г.Астана, р-н Нура, пр. Улы Дала, дом, 35, н.п. 14',
    kz: 'Астана қ, р-н Нұра, пр. Ұлы Дала, дом, 35, н.п. 14',
    en: 'Astana, Uly Dala street, 35A'
  },
  'contact.phone': {
    ru: 'Телефон',
    kz: 'Телефон',
    en: 'Phone'
  },
  'contact.phone.value': {
    ru: '+7 (706) 606-3636',
    kz: '+7 (706) 606-3636',
    en: '+7 (706) 606-3636'
  },
  'contact.email': {
    ru: 'Электронная почта',
    kz: 'Электрондық пошта',
    en: 'Email'
  },
  'contact.email.value': {
    ru: 'smo@csmed.kz',
    kz: 'smo@csmed.kz',
    en: 'smo@csmed.kz'
  },
  'contact.hours': {
    ru: 'Часы работы',
    kz: 'Жұмыс уақыты',
    en: 'Working Hours'
  },
  'contact.hours.value': {
    ru: 'Пн-Пт: 8:00 - 17:00',
    kz: 'Дс-Жм: 8:00 - 17:00',
    en: 'Mon-Fri: 8:00 - 17:00'
  },
  'contact.message': {
    ru: 'Сообщение',
    kz: 'Хабарлама',
    en: 'Message'
  },
  'contact.message.placeholder': {
    ru: 'Введите ваше сообщение',
    kz: 'Хабарламаңызды енгізіңіз',
    en: 'Enter your message'
  },

  // Footer
  'footer.rights': {
    ru: '© 2023 Спортивный Медицинский Центр Казахстана. Все права защищены.',
    kz: '© 2023 Қазақстанның Спорт Медицина Орталығы. Барлық құқықтар қорғалған.',
    en: '© 2023 Sports Medical Center of Kazakhstan. All rights reserved.'
  },
  'footer.policy': {
    ru: 'Политика конфиденциальности',
    kz: 'Құпиялылық саясаты',
    en: 'Privacy Policy'
  },
  'footer.terms': {
    ru: 'Условия использования',
    kz: 'Қолдану шарттары',
    en: 'Terms of Use'
  },
  'compliance.title': {
    ru: 'Комплаенс служба',
    kz: 'Комплаенс қызметі',
    en: 'Compliance Service'
  },
  'compliance.description': {
    ru: 'Здесь вы найдете документы, относящиеся к комплаенс службе и политики учреждения. Вы можете скачать необходимые документы, нажав на кнопки ниже.',
    kz: 'Мұнда сіз комплаенс қызметіне және мекеме саясатына қатысты құжаттарды таба аласыз. Төменде берілген батырмаларды басу арқылы қажетті құжаттарды жүктеп ала аласыз.',
    en: 'Here you will find documents related to the compliance service and institution policies. You can download the necessary documents by clicking the buttons below.'
  },
  'compliance.document': {
    ru: 'Документ',
    kz: 'Құжат',
    en: 'Document'
  },
  'compliance.download': {
    ru: 'Скачать',
    kz: 'Жүктеп алу',
    en: 'Download'
  },
  'compliance.view': {
    ru: 'Просмотреть',
    kz: 'Қарау',
    en: 'View'
  },
  'compliance.document.description': {
    ru: 'Ознакомьтесь с содержимым документа или скачайте его по кнопке ниже.',
    kz: 'Құжаттың мазмұнымен танысыңыз немесе төмендегі батырма арқылы жүктеп алыңыз.',
    en: 'View the document content or download it using the button below.'
  },
  'compliance.close': {
    ru: 'Закрыть',
    kz: 'Жабу',
    en: 'Close'
  },

  // Director Contact Form
  'director.contact.button': {
    ru: 'Написать директору',
    kz: 'Директорға жазу',
    en: 'Write to Director'
  },
  'director.contact.title': {
    ru: 'Обращение к директору',
    kz: 'Директорға хабарлама',
    en: 'Message to Director'
  },
  'director.contact.subtitle': {
    ru: 'Отправьте ваше обращение напрямую директору центра',
    kz: 'Орталық директорына тікелей хабарламаңызды жіберіңіз',
    en: 'Send your message directly to the center director'
  },
  'director.contact.name': {
    ru: 'Ваше имя',
    kz: 'Сіздің атыңыз',
    en: 'Your Name'
  },
  'director.contact.email': {
    ru: 'Ваш email',
    kz: 'Сіздің email',
    en: 'Your Email'
  },
  'director.contact.phone': {
    ru: 'Ваш телефон',
    kz: 'Сіздің телефоныңыз',
    en: 'Your Phone'
  },
  'director.contact.subject': {
    ru: 'Тема обращения',
    kz: 'Хабарлама тақырыбы',
    en: 'Message Subject'
  },
  'director.contact.message': {
    ru: 'Текст обращения',
    kz: 'Хабарлама мәтіні',
    en: 'Message Text'
  },
  'director.contact.message.placeholder': {
    ru: 'Опишите ваше обращение...',
    kz: 'Хабарламаңызды сипаттаңыз...',
    en: 'Describe your message...'
  },
  'director.contact.send': {
    ru: 'Отправить обращение',
    kz: 'Хабарлама жіберу',
    en: 'Send Message'
  },
  'director.contact.sending': {
    ru: 'Отправка...',
    kz: 'Жіберілуде...',
    en: 'Sending...'
  },
  'director.contact.success': {
    ru: 'Обращение отправлено',
    kz: 'Хабарлама жіберілді',
    en: 'Message Sent'
  },
  'director.contact.success.description': {
    ru: 'Ваше обращение успешно отправлено директору. Мы свяжемся с вами в ближайшее время.',
    kz: 'Сіздің хабарламаңыз директорға сәтті жіберілді. Біз жақын арада сізбен байланысамыз.',
    en: 'Your message has been successfully sent to the director. We will contact you soon.'
  },
  'director.contact.error': {
    ru: 'Ошибка отправки',
    kz: 'Жіберу қатесі',
    en: 'Send Error'
  },
  'director.contact.error.description': {
    ru: 'Произошла ошибка при отправке обращения. Пожалуйста, попробуйте еще раз.',
    kz: 'Хабарлама жіберу кезінде қате орын алды. Қайталап көріңіз.',
    en: 'An error occurred while sending the message. Please try again.'
  }
};
